/**
 * Quando um modal é **diálogo centralizado** e quando é **folha inferior** —
 * a regra do `ReusableModal`, a mesma nas duas entradas.
 *
 * No web ela era só uma media query (`(min-width: 640px)`, o `sm` do
 * Tailwind) dentro do `use-media-query.ts`; o nativo não tinha de onde lê-la.
 * Agora o número mora aqui, o web deriva a media query dele e o nativo compara
 * com a largura da janela — celular abre folha, tablet abre diálogo, pela
 * mesma conta.
 *
 * Sem import de framework: é lida pelos dois barris. O número mora no
 * `@tami/tokens` (`BREAKPOINTS.modalDialog`) desde 2026-09-14.
 */
import { BREAKPOINTS } from "@tami/tokens";

export const LARGURA_MINIMA_DO_DIALOGO_PX = BREAKPOINTS.modalDialog;

export type ApresentacaoDoModal = "dialogo" | "folha";

export function apresentacaoDoModal(larguraPx: number): ApresentacaoDoModal {
  return larguraPx >= LARGURA_MINIMA_DO_DIALOGO_PX ? "dialogo" : "folha";
}
